import { useCompleteFragment } from '@eluve/apollo-client';

import { baseTemplateFragment } from './operations';

export const useIsTemplateDraft = (outputTemplateId: string) => {
  const data = useCompleteFragment({
    fragment: baseTemplateFragment,
    key: { id: outputTemplateId },
  });

  return {
    isDraft: data?.isDraft ?? false,
  };
};
